const MAP_STYLES = [{
  "featureType": "administrative",
  "elementType": "labels.text.fill",
  "stylers": [{ "color": "#686868" }]
},
{
  "featureType": "landscape",
  "elementType": "all",
  "stylers": [{ "color": "#f2f2f2" }]
},
{
  "featureType": "poi",
  "elementType": "all",
  "stylers": [{ "visibility": "off" }]
},
{
  "featureType": "road",
  "elementType": "all",
  "stylers": [{ "saturation": -100 }, { "lightness": 45 }]
},
{
  "featureType": "road.highway",
  "elementType": "all",
  "stylers": [{ "visibility": "simplified" }]
},
{
  "featureType": "road.highway",
  "elementType": "geometry.fill",
  "stylers": [{ "lightness": "-22" }]
},
{
  "featureType": "road.highway",
  "elementType": "geometry.stroke",
  "stylers": [{ "saturation": "11" }, { "lightness": "-51" }]
},
{
  "featureType": "road.highway",
  "elementType": "labels.text",
  "stylers": [{ "saturation": "3" }, { "lightness": "-56" }, { "weight": "2.20" }]
},
{
  "featureType": "road.highway",
  "elementType": "labels.text.fill",
  "stylers": [{ "lightness": "-52" }]
},
{
  "featureType": "road.highway",
  "elementType": "labels.text.stroke",
  "stylers": [{ "weight": "6.13" }]
},
{
  "featureType": "road.highway",
  "elementType": "labels.icon",
  "stylers": [{ "lightness": "-10" }, { "gamma": "0.94" }, { "weight": "1.24" }, { "saturation": "-100" }, { "visibility": "off" }]
},
{
  "featureType": "road.arterial",
  "elementType": "geometry",
  "stylers": [{ "lightness": "-16" }]
},
{
  "featureType": "road.arterial",
  "elementType": "labels.text.fill",
  "stylers": [{ "saturation": "-41" }, { "lightness": "-41" }]
},
{
  "featureType": "road.arterial",
  "elementType": "labels.text.stroke",
  "stylers": [{ "weight": "5.46" }]
},
{
  "featureType": "road.arterial",
  "elementType": "labels.icon",
  "stylers": [{ "visibility": "off" }]
},
{
  "featureType": "road.local",
  "elementType": "geometry.fill",
  "stylers": [{ "weight": "0.72" }, { "lightness": "-16" }]
},
{
  "featureType": "road.local",
  "elementType": "labels.text.fill",
  "stylers": [{ "lightness": "-37" }]
},
{
  "featureType": "transit",
  "elementType": "all",
  "stylers": [{ "visibility": "off" }]
},
{
  "featureType": "water",
  "elementType": "all",
  "stylers": [{ "color": "#b7e4f4" }, { "visibility": "on" }]
}]

const customRenderer = {
  render: ({ count, position }) => {

    const svg = window.btoa(`
      <svg fill="#d8232f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" opacity=".9" r="70" />
        <circle cx="120" cy="120" opacity=".3" r="90" />
      </svg>`);

    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(46, 46),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(40, 40),
      },
      label: {
        text: String(count),
        color: "rgba(255,255,255,0.9)",
        fontSize: "14px",
        fontWeight: "bold",
      },
      optimized: false,
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  },
};

const PIN_SVG = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 240 240" width="240" height="240">
  <path fill="#d8232f" d="M119.69,0C74.27,0,28.85,30.26,24.56,90.82c-3.98,56.27,44.72,109.98,87.98,146.54,4.17,3.51,10.13,3.51,14.31,0,43.25-36.57,91.97-90.26,87.98-146.54C210.55,30.26,165.11,0,119.7,0h0Z"/>
  <circle fill="#fff" cx="119.52" cy="95.34" r="75.06"/>
  <polygon fill="#d8232f" points="78.05 94.16 114.99 98.52 118.8 135.58 165.2 48.13 78.05 94.16"/>
  <polygon fill="#d8232f" points="87.12 73.59 52.56 91.92 69.77 93.77 104.21 75.3 87.12 73.59"/>
  <polygon fill="#d8232f" points="119.59 143.63 121.43 160.77 139.7 126.08 137.99 108.94 119.59 143.63"/>
</svg>`);

const STAR_SVG = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 240 240" width="240" height="240">
  <path fill="#F9C748" d="M119.69,0C74.27,0,28.85,30.26,24.56,90.82c-3.98,56.27,44.72,109.98,87.98,146.54,4.17,3.51,10.13,3.51,14.31,0,43.25-36.57,91.97-90.26,87.98-146.54C210.55,30.26,165.11,0,119.7,0h0Z"/>
  <circle fill="#fff" cx="119.52" cy="95.34" r="75.06"/>
  <polygon fill="#d8232f" points="78.05 94.16 114.99 98.52 118.8 135.58 165.2 48.13 78.05 94.16"/>
  <polygon fill="#d8232f" points="87.12 73.59 52.56 91.92 69.77 93.77 104.21 75.3 87.12 73.59"/>
  <polygon fill="#d8232f" points="119.59 143.63 121.43 160.77 139.7 126.08 137.99 108.94 119.59 143.63"/>
</svg>`);

if (!customElements.get("location-store")) {
  class LocationStore extends HTMLElement {
    constructor() {
      super();

      this.markers = new Map();
      this.markerClusterer = null;
      this.debounceTimeout = null;
      this.userLocation = null;
      this.searchLocation = null;
      this.mapElm = this.querySelector('#location-map');
      this.noResults = this.querySelector('.no-results');
      this.searchInput = this.querySelector('#location-search');
      this.searchClearBtn = this.querySelector('.search-form--clear');
      this.locationsListElement = this.querySelector('.locations-list');
      this.filterButtons = this.querySelectorAll('.filter-btn');
      this.searchBtn = this.querySelector('#search-btn');
      this.mapError = this.querySelector('.map-error');

      if (!HimiSettings.gm_api || !this.mapElm) {
        this.unfondDisplay();
        return;
      }

      this.data = this.dataset.locations;
      this.dataCard = this.dataset.locationsCard;
      this.formatDistance = this.dataset.formatDistance || 'km';
      this.lat = parseFloat(this.dataset.lat) || 33.994;
      this.lng = parseFloat(this.dataset.lng) || -117.876;
    }

    async connectedCallback() {
      if (!this.data) {
        this.unfondDisplay();
        return;
      }

      this.showLoading();

      try {
        const [storeLocations, cardsMap] = await Promise.all([
          fetchCache(this.data, { mode: 'cors' }),
          this.fetchCardTemplateFromUrl()
        ]);
        this.cardsMapFromUrl = cardsMap;
        this.locations = JSON.parse(storeLocations).map((location, index) => ({ ...location, id: index + 1 }));
        await this.loadGoogleMapsScript();
        await this.initMap();
        this.initApp();
      } catch (error) {
        console.error('Error in LocationStore initialization:', error);
        this.unfondDisplay();
      }
    }

    loadGoogleMapsScript() {
      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          return resolve();
        }
        const script = document.createElement("script");
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${HimiSettings.gm_api}&libraries=places`;
        document.body.appendChild(script);
      });
    }

    async initMap() {
      this.map = new google.maps.Map(this.mapElm, {
        center: { lat: this.lat, lng: this.lng },
        zoom: 5,
        styles: MAP_STYLES,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          mapTypeIds: ['roadmap', 'satellite']
        }
      });

      await new Promise(resolve => google.maps.event.addListenerOnce(this.map, 'idle', resolve));

      this.infoWindow = new google.maps.InfoWindow();
      this.geocoder = new google.maps.Geocoder();
      this.markerClusterer = new markerClusterer.MarkerClusterer({ map: this.map, markers: [], renderer: customRenderer });

      await this.getUserLocation();
      this.map.addListener('idle', () => this.handleMapIdle());
    }

    handleMapIdle() {
      if (!this.map || !this.markers || !this.locations) return;
      const bounds = this.map.getBounds();
      if (!bounds) return;

      const visibleLocations = this.locations.filter(location => {
        const marker = this.markers.get(location.id);
        return marker && bounds.contains(marker.getPosition());
      });

      this.renderLocationsList(visibleLocations);
    }

    showLoading() {
      if (this.mapElm) {
        this.mapElm.innerHTML = '<div class="loading-text flex items-center justify-center h-full text-sm text-color-secondary">' + HimiStrings.map_init + '</div>';
      }
      if (this.locationsListElement) {
        this.locationsListElement.innerHTML = '<div class="loading-text py-10 text-center text-sm text-color-secondary">' + HimiStrings.locations_init + '</div>';
      }
    }

    getUserLocation() {
      return new Promise(resolve => {
        if (!navigator.geolocation) {
          return resolve();
        }

        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            this.addUserMarker(this.userLocation);
            this.calculateDistances();
            resolve();
          },
          (error) => {
            console.error("Error getting user location:", error);
            resolve();
          },
          { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 }
        );
      });
    }

    addUserMarker(location) {
      if (this.userMarker) {
        this.userMarker.setMap(null);
      }
      this.userMarker = new google.maps.Marker({
        position: location,
        map: this.map,
        zIndex: 1000
      });
      this.map.setCenter(location);
      this.map.setZoom(13);
    }

    addSearchMarker(location) {
      if (this.searchMarker) {
        this.searchMarker.setMap(null);
      }
      this.searchMarker = new google.maps.Marker({
        position: location,
        map: this.map,
        zIndex: 1001
      });
      this.map.setCenter(location);
      this.map.setZoom(13);
    }

    calculateDistances() {
      const origin = this.searchLocation || this.userLocation;
      if (!origin) return;
      this.locations.forEach(location => {
        const lat = parseFloat(location.lat);
        const lng = parseFloat(location.lng);
        if (!lat || !lng) {
          location.distance = null;
          location.distanceValue = Infinity;
          return;
        }
        const distance = this.calculateHaversineDistance(origin.lat, origin.lng, lat, lng);
        const distanceInUnits = this.formatDistance === 'km' ? distance / 1000 : distance / 1609.34;
        location.distance = `${distanceInUnits.toFixed(1)} ${this.formatDistance === 'km' ? 'km' : 'mi'}`;
        location.distanceValue = distance;
      });

      this.locations.sort((a, b) => a.distanceValue - b.distanceValue);
    }

    calculateHaversineDistance(lat1, lon1, lat2, lon2) {
      const R = 6371000;
      const φ1 = lat1 * Math.PI / 180;
      const φ2 = lat2 * Math.PI / 180;
      const Δφ = (lat2 - lat1) * Math.PI / 180;
      const Δλ = (lon2 - lon1) * Math.PI / 180;
      const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    updateUI(filterType, searchQuery) {
      const locations = this.filterLocations(filterType, searchQuery);
      this.addMarkersToMap(locations);
      this.renderLocationsList(locations);
    }

    addMarkersToMap(locationsToShow) {
      this.markerClusterer.clearMarkers();
      this.markers.clear();
      if (!locationsToShow?.length) return;

      const bounds = new google.maps.LatLngBounds();

      const newMarkers = locationsToShow
        .filter(loc => parseFloat(loc.lat) && parseFloat(loc.lng))
        .map(location => {
          const lat = parseFloat(location.lat);
          const lng = parseFloat(location.lng);
          const position = { lat, lng };
          const icon = location.star_store ? STAR_SVG : PIN_SVG;

          const marker = new google.maps.Marker({
            position,
            icon: {
              url: `data:image/svg+xml;base64,${icon}`,
              scaledSize: new google.maps.Size(36, 36),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(18, 36)
            },
            optimized: false,
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + 1
          });

          marker.addListener('click', () => this.handleMarkerClick(marker, location));
          bounds.extend(position);
          this.markers.set(location.id, marker);
          return marker;
        });

      this.markerClusterer.addMarkers(newMarkers);

      if (this.userLocation) bounds.extend(this.userLocation);
      if (this.searchLocation) bounds.extend(this.searchLocation);

      this.map.fitBounds(bounds);

      if (newMarkers.length === 1 && !this.userLocation) {
        google.maps.event.addListenerOnce(this.map, 'idle', () => {
          if (this.map.getZoom() > 15) {
            this.map.setZoom(15);
          }
        });
      }
    }


    handleMarkerClick(marker, location) {
      this.infoWindow.setHeaderContent(location.title);
      this.infoWindow.setContent(this.createInfoWindowContent(location));
      this.infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -10) });
      this.infoWindow.open(this.map, marker);
      this.highlightLocationCard(location.id);
    }

    createInfoWindowContent(location) {
      const imageContent = location.image ? `<img src="${location.image}" alt="${location.title}" class="w-full h-full object-cover mb-2 w-80">` : '';
      const phoneContent = location.phone ? `<li><a href="tel:${location.phone}" class="flex items-center gap-2"><svg class="icon svg-icon--medium-small" fill="currentColor"><use href="#phone"></use></svg>${location.phone}</a></li>` : '';
      const emailContent = location.email ? `<li><a href="mailto:${location.email}" class="flex items-center gap-2"><svg class="icon svg-icon--medium-small" fill="currentColor"><use href="#mail"></use></svg>${location.email}</a></li>` : '';
      const websiteContent = location.website ? `<li><a href="https://${location.website}" class="flex items-center gap-2" target="_blank"><svg class="icon svg-icon--medium-small" fill="currentColor"><use href="#website"></use></svg>${location.website}</a></li>` : '';
      const hoursContent = location.hours ? `<li class="flex items-center gap-2"><svg class="icon svg-icon--medium-small" fill="currentColor"><use href="#time"></use></svg>${location.hours}</li>` : '';

      const contacts = [phoneContent, emailContent, websiteContent, hoursContent].filter(Boolean).join('');
      const contactsList = contacts ? `<ul class="flex flex-col gap-2 text-sm text-color-secondary mt-2">${contacts}</ul>` : '';
      const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`;
      const cardEl = this.cardsMapFromUrl?.get(String(location.id));
      const locationInfoEl = cardEl?.querySelector('.location-info');
      const locationInfoContent = locationInfoEl ? locationInfoEl.outerHTML : '';

      return `
        <div class="custom-info-window">
          ${imageContent}
          <div class="text-sm text-color-secondary">${location.address}</div>
          ${contactsList}
          ${locationInfoContent}
          <a href="${directionsUrl}" target="_blank" class="button button--small button--secondary w-full mt-3">
            ${HimiStrings.directions}
          </a>
        </div>
      `;
    }

    renderLocationsList(locationsToShow) {
      this.locationsListElement.innerHTML = '';
      if (!locationsToShow?.length) {
        this.noResults?.classList.remove('hidden');
      } else {
        this.noResults?.classList.add('hidden');
        const fragment = document.createDocumentFragment();
        locationsToShow.forEach(location => {
          const card = this.createLocationCard(location);
          if (card) fragment.appendChild(card);
        });
        this.locationsListElement.appendChild(fragment);
      }
    }

    async fetchCardTemplateFromUrl() {
      try {
        const cardUrl = this.dataCard || `${window.location.pathname}?view=location-card`;
        const response = await fetch(cardUrl);
        if (!response.ok) return null;
        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const cardsMap = new Map();
        doc.querySelectorAll('.location-card').forEach(card => {
          if (card.dataset.id) {
            cardsMap.set(String(card.dataset.id), card);
          }
        });
        return cardsMap;
      } catch (error) {
        console.error('Error fetching location card DOM from URL:', error);
        return null;
      }
    }

    createLocationCard(location) {
      const locationCard = this.cardsMapFromUrl?.get(String(location.id))?.cloneNode(true);
      if (!locationCard) return null;

      const distanceContainer = locationCard.querySelector('.js-location-distance-container');
      const distanceEl = locationCard.querySelector('.js-location-distance');

      if (location.distance) {
        if (distanceEl) distanceEl.textContent = location.distance;
        if (distanceContainer) distanceContainer.classList.remove('hidden');
      } else {
        if (distanceContainer) distanceContainer.classList.add('hidden');
      }

      locationCard.addEventListener('click', () => this.handleLocationCardClick(location));
      return locationCard;
    }

    handleLocationCardClick(location) {
      const position = new google.maps.LatLng(parseFloat(location.lat), parseFloat(location.lng));
      this.map.setCenter(position);
      this.map.setZoom(14);
      this.infoWindow.setHeaderContent(location.title);
      this.infoWindow.setContent(this.createInfoWindowContent(location));
      this.infoWindow.setPosition(position);
      this.infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -50) });
      this.infoWindow.open(this.map);
      this.highlightLocationCard(location.id);
    }

    highlightLocationCard(locationId) {
      this.querySelectorAll('.location-card').forEach(card => card.classList.remove('active'));
      const activeCard = this.querySelector(`.location-card[data-id="${locationId}"]`);
      if (activeCard) {
        activeCard.classList.add('active');
        activeCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    normalizeText(text) {
      if (!text) return '';
      return text
        .toLowerCase()
        .replace(/[.,\-#/'&()]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    filterLocations(filterType = 'all', searchQuery = '') {
      const normalizedQuery = this.normalizeText(searchQuery);
      const queryTokens = normalizedQuery.split(' ').filter(Boolean);

      return this.locations.filter(location => {
        const matchesType = filterType === 'all' || location.type === filterType;
        if (!normalizedQuery) return matchesType;

        const haystack = [
          location.title,
          location.address,
          location.phone,
          location.email,
          location.website
        ].filter(Boolean).map(f => this.normalizeText(f)).join(' ');

        const matchesSearch = queryTokens.every(token => haystack.includes(token));
        return matchesType && matchesSearch;
      });
    }

    handleFilterClick(event) {
      const button = event.currentTarget;
      this.filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      this.updateUI(button.dataset.type, this.searchInput.value.trim());
    }

    handleSearch(event) {
      const currentFilter = this.querySelector('.filter-btn.active')?.dataset.type || 'all';
      const currentSearch = event.target.value.trim();
      clearTimeout(this.debounceTimeout);
      this.updateClearButtonVisibility(currentSearch);
      this.debounceTimeout = setTimeout(() => {
        this.updateUI(currentFilter, currentSearch);
      }, 300);
    }

    initApp() {
      this.updateUI('all', '');
      this.filterButtons.forEach(button => {
        button.addEventListener('click', this.handleFilterClick.bind(this));
      });
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => {
          this.updateClearButtonVisibility(this.searchInput.value.trim());
        });
        this.searchInput.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.doSearch(this.searchInput.value.trim());
          }
        });
        this.createSearchClearButton();
        this.updateClearButtonVisibility(this.searchInput.value.trim());
      }
      if (this.searchBtn) {
        this.searchBtn.addEventListener('click', () => {
          this.doSearch(this.searchInput?.value.trim());
        });
      }
    }

    doSearch(query) {
      if (!query) return;
      const currentFilter = this.querySelector('.filter-btn.active')?.dataset.type || 'all';
      this.updateUI(currentFilter, query);
    }

    createSearchClearButton() {
      if (!this.searchInput || !this.searchClearBtn) return;
      this.searchClearBtn.addEventListener('click', () => {
        clearTimeout(this.debounceTimeout);
        this.searchInput.value = '';
        this.searchLocation = null;
        if (this.searchMarker) {
          this.searchMarker.setMap(null);
          this.searchMarker = null;
        }
        const currentFilter = this.querySelector('.filter-btn.active')?.dataset.type || 'all';
        this.calculateDistances();
        this.updateUI(currentFilter, '');
        this.updateClearButtonVisibility('');
      });
      this.searchInput.insertAdjacentElement('afterend', this.searchClearBtn);
    }

    updateClearButtonVisibility(value) {
      if (!this.searchClearBtn) return;
      const hasValue = !!value;
      this.searchClearBtn.style.visibility = hasValue ? 'visible' : 'hidden';
    }

    unfondDisplay() {
      this.mapElm.classList.add('hidden');
      this.mapError.classList.remove('hidden')
    }
  }

  customElements.define("location-store", LocationStore);
}